"use client";

import { ShoppingCart, Languages } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Link, usePathname } from "@/i18n/navigation";
import { useTranslations, useLocale } from "next-intl";
import { useStore } from "@/lib/store";
import { useRouter } from "@/i18n/navigation";
import { useState, useEffect } from "react";
import { ThemeToggle } from "@/components/theme-toggle";
import { routing } from "@/i18n/routing";
import {
  SignedIn,
  SignedOut,
  SignInButton,
  SignUpButton,
  UserButton,
} from "@clerk/nextjs";

export function Header() {
  const t = useTranslations('header');
  const tCommon = useTranslations('common');
  const locale = useLocale();
  const { cart } = useStore();
  const router = useRouter();
  const pathname = usePathname();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleLocaleChange = (newLocale: string) => {
    // next-intl의 router를 사용하면 자동으로 locale을 처리합니다
    router.push(pathname, { locale: newLocale });
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between">
          <Link href="/" className="font-bold text-2xl text-primary">
            {t('title')}
          </Link>

          <div className="flex items-center gap-3">
            <ThemeToggle />
            
            {/* Language Switcher */}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon">
                  <Languages className="w-5 h-5" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                {routing.locales.map((loc) => (
                  <DropdownMenuItem
                    key={loc}
                    onClick={() => handleLocaleChange(loc)}
                    className={locale === loc ? "bg-accent" : ""}
                  >
                    {loc === 'ko' ? '한국어' : 'English'}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>

            <SignedOut>
              <SignInButton>
                <Button>{tCommon('login')}</Button>
              </SignInButton>
              <SignUpButton>
                <Button variant="outline">{tCommon('signup')}</Button>
              </SignUpButton>
            </SignedOut>

            <SignedIn>
              <Button variant="ghost" size="icon" className="relative" asChild>
                <Link href="/cart">
                  <ShoppingCart className="w-5 h-5" />
                  {mounted && cart.length > 0 && (
                    <span className="absolute -top-1 -right-1 bg-primary text-primary-foreground text-xs w-5 h-5 rounded-full flex items-center justify-center font-semibold">
                      {cart.length}
                    </span>
                  )}
                </Link>
              </Button>

              <UserButton />
            </SignedIn>
          </div>
        </div>
      </div>
    </header>
  );
}
